export default __webpack_public_path__ + "static/media/acadd.e6ad07aa.jpg";